import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import MaintenancePage from '@/pages/MaintenancePage';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const resolveUrl = (u) => (u?.startsWith('http') ? u : u ? `${BACKEND_URL}${u}` : null);

const isAdminPath = (pathname) => pathname.startsWith('/admin');

/**
 * MaintenanceGate:
 *  - Fetches /api/settings on mount and on route change
 *  - Sets the browser favicon to the uploaded logo when available
 *  - If maintenance_mode is ON and the visitor is not on /admin/*, renders MaintenancePage instead
 */
const MaintenanceGate = ({ children }) => {
  const location = useLocation();
  const [settings, setSettings] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/settings`);
        if (!cancelled) setSettings(data);
      } catch {
        if (!cancelled) setSettings({});
      } finally {
        if (!cancelled) setLoaded(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [location.pathname]);

  // Dynamically update favicon when logo is set
  useEffect(() => {
    const logoUrl = resolveUrl(settings?.logo_url);
    if (!logoUrl) return;
    const link = document.getElementById('app-favicon');
    if (link) link.setAttribute('href', logoUrl);
  }, [settings?.logo_url]);

  if (!loaded) return null;

  const inMaintenance = !!settings?.maintenance_mode;
  const isAdmin = isAdminPath(location.pathname);

  if (inMaintenance && !isAdmin) {
    return (
      <MaintenancePage
        logoUrl={resolveUrl(settings?.logo_url)}
        message={settings?.maintenance_message}
        socials={{
          spotify_url: settings?.spotify_url,
          soundcloud_url: settings?.soundcloud_url,
          instagram_url: settings?.instagram_url,
          tiktok_url: settings?.tiktok_url,
          facebook_url: settings?.facebook_url,
          messenger_url: settings?.messenger_url,
        }}
      />
    );
  }

  return children;
};

export default MaintenanceGate;
